import apiFetch from '../apiFetch'

export default function (idGrupoUsuario, token) {
  return apiFetch({endPoint: `GrupoUsuario/cambiarEstadoGrupoUsuario?idGrupoUsuario=` + idGrupoUsuario, method: 'GET', body: null, token: token})
}